var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQotdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.698,
    height: 22.531,
    fill: "#142735",
    viewBox: "0 0 26.698 22.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7828",
    "data-name": "Group 7828",
    transform: "translate(-45.08 -74.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    "data-name": "Path 9566",
    d: "M54.208,86.733c-4.389-3.393,1.819-8.644,1.819-9.707,0-.493-2.233-2.119-2.639-2.119-1.687,0-12.813,11.254-6.261,19.823C52.62,101.915,62.636,93.248,54.208,86.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    "data-name": "Path 9567",
    d: "M68.532,86.733c-4.39-3.393,1.818-8.644,1.818-9.707,0-.493-2.232-2.119-2.639-2.119-1.687,0-12.812,11.254-6.261,19.823C66.944,101.915,76.96,93.248,68.532,86.733Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQotdIcon);
export default __webpack_public_path__ + "static/media/qotd_icon.8c021304a48ff0515d495b992e33de94.svg";
export { ForwardRef as ReactComponent };